import { Link, Outlet, useParams } from "react-router";
import { findModule, brandHasTool } from "@/lib/modules";
import { useAccountWorkspace } from "@/lib/account-workspace";
import { Button } from "@/components/ui/button";

/** AI 官网五栏壳：品牌未开通则挡；子路由 Outlet */
export default function BrandSiteLayout() {
  const { brandId } = useParams();
  const { accountId, brands, modules, isLoading } = useAccountWorkspace();
  const brand = brands.find((item) => String(item.id) === brandId);
  const app = findModule(modules, "brand_site");
  const brandToolEnabled = brandHasTool(brand, "brand_site");

  if (isLoading) {
    return <p className="text-sm text-muted-foreground">加载中…</p>;
  }

  if (!app || !app.enabled) {
    return (
      <div className="space-y-3">
        <p className="text-sm text-muted-foreground">AI 官网未订阅或不存在。</p>
        {brandId ? (
          <Link
            to={`/accounts/${accountId}/brands/${brandId}`}
            className="text-sm text-primary-readable hover:underline"
          >
            返回品牌
          </Link>
        ) : null}
      </div>
    );
  }

  if (!brand) {
    return (
      <div className="space-y-3">
        <p className="text-sm text-muted-foreground">未找到该品牌。</p>
        <Link to={`/accounts/${accountId}`} className="text-sm text-primary-readable hover:underline">
          返回企业画像
        </Link>
      </div>
    );
  }

  if (!brandToolEnabled) {
    return (
      <div className="rounded-lg border border-dashed border-border bg-card px-6 py-10 text-center">
        <p className="text-sm font-medium text-foreground">本品牌尚未开通 AI 官网</p>
        <p className="mt-1 text-xs text-muted-foreground">
          「{brand.name}」还没打开这个功能。去品牌里开通后即可开始做官网。
        </p>
        <Button asChild className="mt-4" size="sm">
          <Link to={`/accounts/${accountId}/brands/${brandId}`}>前往品牌开通</Link>
        </Button>
      </div>
    );
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <Outlet />
    </div>
  );
}
